import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MforderPageImpl from './MforderPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MforderPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < MforderPageImpl />
    )

}